const IMAGE_MAX_WIDTH = 250

const resizeImageWithDataUrl = ({
  dataUrl,
  keepRatio,
  width,
  height,
}: {
  dataUrl: string
  keepRatio?: boolean
  width?: number
  height?: number
}) => {
  const img = new Image()

  return new Promise<string>((resolve, reject) => {
    img.onload = () => {
      let imgWidth = width || img.width
      let imgHeight = height || img.height

      if (imgWidth > IMAGE_MAX_WIDTH) {
        if (keepRatio) {
          imgHeight = Math.round((imgHeight * IMAGE_MAX_WIDTH) / imgWidth)
        }

        imgWidth = IMAGE_MAX_WIDTH
      }

      const canvas = document.createElement("canvas")
      canvas.width = imgWidth
      canvas.height = imgHeight

      const ctx = canvas.getContext("2d")
      if (ctx) {
        ctx.drawImage(img, 0, 0, imgWidth, imgHeight)
        const resizedBase64 = canvas.toDataURL("image/png")
        resolve(resizedBase64)
      } else {
        reject(new Error("Could not get canvas context"))
      }
    }

    img.src = dataUrl
  })
}

export default resizeImageWithDataUrl
